import React, { useCallback, useState, useEffect } from 'react'
import { Alert, Button } from 'react-bootstrap'
import Progress from '../Form/Progress'
import { useLocalReceiptDataState } from '../../../stores/LocalReceiptDataProvider'
import { ButtonWithLoadingState } from '../../Buttons'
import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'

const StyledContainer = styled.div`
  @media screen and (min-width: 1081px) {
    position: sticky;
    top: 50px;
  }
`
const StyledCancelButton = styled(Button)`
  width: 100%;
  max-width: 250px;
  @media (max-width: 576px) {
    max-width: none !important;
  }
`
const EditReceiptSidebar = () => {
  const {
    submitEditReceipt,
    errorsOccurredOnSubmit,
    formDataHasChanged,
    resetFormData,
    setSuccessSubmit,
    successSubmit,
    loadedReceiptData,
  } = useLocalReceiptDataState()
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = useCallback(
    async (e) => {
      setSuccessSubmit(false)
      setIsLoading(true)
      formDataHasChanged && (await submitEditReceipt())
      setIsLoading(false)
    },
    [formDataHasChanged, setSuccessSubmit, submitEditReceipt]
  )

  const handleClickCancel = () => {
    resetFormData()
  }
  useEffect(() => {
    let timeout = null
    if (!isLoading && !!successSubmit) {
      timeout = setTimeout(() => {
        setSuccessSubmit(false)
      }, 3000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [isLoading, successSubmit, setSuccessSubmit])

  const { t } = useTranslation()

  return (
    <StyledContainer>
      <header>
        <div className='h2'>{t('goodsReceiptOverlayProgress:headerEdit')}</div>
      </header>
      <div className='content'>
        <ButtonWithLoadingState
          className='submit-btn mb-3'
          isLoading={isLoading}
          onClick={handleSubmit}
          disabled={isLoading || !formDataHasChanged || !loadedReceiptData}
          buttonText={t('OverlayProgress:save')}
          loadingText={t('OverlayProgress:save')}
        />
        {formDataHasChanged && (
          <>
            <StyledCancelButton
              className='mb-3'
              variant='secondary'
              onClick={handleClickCancel}
            >
              {t('cancelButton')}
            </StyledCancelButton>
            <div className=' alert alert-info'>
              {t('EmployeeFormHealthData:dataChange')}
            </div>
          </>
        )}

        {!isLoading && !!errorsOccurredOnSubmit && (
          <Alert variant='danger'>
            <Trans i18nKey='goodsReceiptOverlayProgress:danger' />
          </Alert>
        )}
        {!isLoading && !!successSubmit && (
          <Alert variant='success'>
            {t('goodsReceiptOverlayProgress:updated')}
          </Alert>
        )}
        <Progress />
      </div>
    </StyledContainer>
  )
}

export default EditReceiptSidebar
